(function () {
  var FLIP_MS = 250;
  var GROUPS = ['days', 'hours', 'minutes', 'seconds'];

  function pad2(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function getSecondsUntilMidnight(timezone) {
    var now = new Date();

    if (!timezone || timezone === 'visitor') {
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      return Math.max(0, Math.floor((end - now) / 1000));
    }

    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(now);

    function part(type) {
      var p = parts.find(function (x) { return x.type === type; });
      return p ? parseInt(p.value, 10) : 0;
    }

    var h = part('hour');
    var m = part('minute');
    var s = part('second');
    if (h === 24) h = 0;
    var elapsed = h * 3600 + m * 60 + s;
    return Math.max(0, 86400 - elapsed);
  }

  function getZonedParts(date, timezone) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date);
    var result = {};
    parts.forEach(function (item) {
      if (item.type !== 'literal') result[item.type] = parseInt(item.value, 10);
    });
    if (result.hour === 24) result.hour = 0;
    return result;
  }

  function sameDateTime(parts, values) {
    return parts.year === values.year &&
      parts.month === values.month &&
      parts.day === values.day &&
      parts.hour === values.hour &&
      parts.minute === values.minute &&
      parts.second === values.second;
  }

  function zonedDateTimeToDate(values, timezone) {
    var desiredUtc = Date.UTC(
      values.year,
      values.month - 1,
      values.day,
      values.hour,
      values.minute,
      values.second
    );
    var guess = desiredUtc;

    for (var i = 0; i < 4; i += 1) {
      var actual = getZonedParts(new Date(guess), timezone);
      var actualUtc = Date.UTC(
        actual.year,
        actual.month - 1,
        actual.day,
        actual.hour,
        actual.minute,
        actual.second
      );
      var adjustment = desiredUtc - actualUtc;
      guess += adjustment;
      if (adjustment === 0) break;
    }

    var resolved = new Date(guess);
    return sameDateTime(getZonedParts(resolved, timezone), values) ? resolved : null;
  }

  function parseDeadline(dateText, timeText, timezone) {
    var dateMatch = String(dateText || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!dateMatch) return null;

    var normalizedTime = String(timeText || '').trim() || '23:59:59';
    var timeMatch = normalizedTime.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!timeMatch) return null;

    var values = {
      year: parseInt(dateMatch[1], 10),
      month: parseInt(dateMatch[2], 10),
      day: parseInt(dateMatch[3], 10),
      hour: parseInt(timeMatch[1], 10),
      minute: parseInt(timeMatch[2], 10),
      second: timeMatch[3] ? parseInt(timeMatch[3], 10) : 0
    };
    if (
      values.month < 1 || values.month > 12 ||
      values.day < 1 || values.day > 31 ||
      values.hour > 23 || values.minute > 59 || values.second > 59
    ) return null;

    if (!timezone || timezone === 'visitor') {
      var localDate = new Date(
        values.year,
        values.month - 1,
        values.day,
        values.hour,
        values.minute,
        values.second,
        0
      );
      var localParts = {
        year: localDate.getFullYear(),
        month: localDate.getMonth() + 1,
        day: localDate.getDate(),
        hour: localDate.getHours(),
        minute: localDate.getMinutes(),
        second: localDate.getSeconds()
      };
      return sameDateTime(localParts, values) ? localDate : null;
    }

    try {
      return zonedDateTimeToDate(values, timezone);
    } catch (error) {
      return null;
    }
  }

  function splitCountdown(totalSeconds) {
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60
    };
  }

  function srSummary(labels, time) {
    var bits = [];
    if (time.days) bits.push(time.days + ' ' + labels.days);
    if (time.hours) bits.push(time.hours + ' ' + labels.hours);
    if (time.minutes) bits.push(time.minutes + ' ' + labels.minutes);
    if (time.seconds) bits.push(time.seconds + ' ' + labels.seconds);
    return bits.length ? bits.join(', ') + ' remaining' : 'Countdown ended';
  }

  function createDigitList(digit) {
    var list = document.createElement('div');
    list.className = 'ht-flip-clock-list';
    list.style.animationDuration = FLIP_MS + 'ms';
    list.style.animationDelay = FLIP_MS + 'ms';

    function face(value, state) {
      var item = document.createElement('div');
      item.className = 'ht-flip-clock-list-item ' + state;
      var inner = document.createElement('div');
      inner.className = 'ht-flip-clock-list-item-inner';
      var top = document.createElement('div');
      top.className = 'ht-top';
      top.textContent = value;
      var bottom = document.createElement('div');
      bottom.className = 'ht-bottom';
      bottom.textContent = value;
      inner.appendChild(top);
      inner.appendChild(bottom);
      item.appendChild(inner);
      return item;
    }

    list.appendChild(face(digit, 'active'));
    list.appendChild(face(digit, 'before'));
    return list;
  }

  function createGroup(key, label) {
    var group = document.createElement('div');
    group.className = 'ht-flip-clock-group';
    group.dataset.hlandFlipGroup = key;
    group.appendChild(createDigitList('0'));
    group.appendChild(createDigitList('0'));
    var labelEl = document.createElement('div');
    labelEl.className = 'ht-flip-clock-label';
    labelEl.textContent = label;
    group.appendChild(labelEl);
    return group;
  }

  function createDivider() {
    var div = document.createElement('div');
    div.className = 'ht-flip-clock-divider';
    div.setAttribute('aria-hidden', 'true');
    var topDot = document.createElement('div');
    topDot.className = 'ht-flip-clock-dot ht-top';
    var bottomDot = document.createElement('div');
    bottomDot.className = 'ht-flip-clock-dot ht-bottom';
    div.appendChild(topDot);
    div.appendChild(bottomDot);
    return div;
  }

  function setListDigit(list, nextDigit) {
    nextDigit = String(nextDigit);
    var active = list.querySelector('.ht-flip-clock-list-item.active');
    var before = list.querySelector('.ht-flip-clock-list-item.before');
    if (!active || !before) return;

    var activeTop = active.querySelector('.ht-top');
    var activeBottom = active.querySelector('.ht-bottom');
    var current = activeTop ? activeTop.textContent : '';

    if (current === nextDigit) return;

    var beforeTop = before.querySelector('.ht-top');
    var beforeBottom = before.querySelector('.ht-bottom');
    if (beforeTop) beforeTop.textContent = current;
    if (beforeBottom) beforeBottom.textContent = current;
    if (activeTop) activeTop.textContent = nextDigit;
    if (activeBottom) activeBottom.textContent = nextDigit;

    list.classList.remove('flip');
    void list.offsetWidth;
    list.classList.add('flip');

    window.setTimeout(function () {
      list.classList.remove('flip');
      if (beforeTop) beforeTop.textContent = nextDigit;
      if (beforeBottom) beforeBottom.textContent = nextDigit;
    }, FLIP_MS + 50);
  }

  function HlandFlipClock(root) {
    this.root = root;
    this.timezone = root.getAttribute('data-hland-countdown-timezone') || 'visitor';
    this.endDate = (root.getAttribute('data-hland-countdown-end-date') || '').trim();
    this.endTime = (root.getAttribute('data-hland-countdown-end-time') || '').trim();
    this.expiredMessage = root.getAttribute('data-hland-countdown-expired') || 'Sale ended';
    this.labels = {
      days: root.getAttribute('data-hland-label-days') || 'Days',
      hours: root.getAttribute('data-hland-label-hours') || 'Hours',
      minutes: root.getAttribute('data-hland-label-minutes') || 'Minutes',
      seconds: root.getAttribute('data-hland-label-seconds') || 'Seconds'
    };
    this.sr = root.querySelector('[data-hland-flip-sr]');
    this.clockEl = root.querySelector('[data-hland-flip-clock]');
    this.expiredEl = root.querySelector('[data-hland-flip-expired]');
    this.deadline = this.endDate ? parseDeadline(this.endDate, this.endTime, this.timezone) : null;
    this.mode = this.deadline ? 'fixed' : 'daily';
    this.isExpired = false;
    this.lastParts = null;
    if (this.endDate && !this.deadline && window.console && typeof window.console.warn === 'function') {
      window.console.warn('Invalid countdown deadline. Falling back to the daily countdown:', this.endDate, this.endTime);
    }
    this.build();
  }

  HlandFlipClock.prototype.build = function () {
    if (!this.clockEl) return;
    this.clockEl.innerHTML = '';
    var self = this;

    GROUPS.forEach(function (key, index) {
      if (index > 0) self.clockEl.appendChild(createDivider());
      self.clockEl.appendChild(createGroup(key, self.labels[key]));
    });
  };

  HlandFlipClock.prototype.updateGroup = function (key, value) {
    var group = this.clockEl.querySelector('[data-hland-flip-group="' + key + '"]');
    if (!group) return;
    var str = key === 'days' ? String(Math.max(0, value)).padStart(2, '0') : pad2(value);
    var lists = group.querySelectorAll('.ht-flip-clock-list');

    if (lists.length !== str.length) {
      Array.prototype.forEach.call(lists, function (list) { list.remove(); });
      var label = group.querySelector('.ht-flip-clock-label');
      str.split('').forEach(function (digit) {
        group.insertBefore(createDigitList(digit), label);
      });
      lists = group.querySelectorAll('.ht-flip-clock-list');
    }

    Array.prototype.forEach.call(lists, function (list, index) {
      setListDigit(list, str.charAt(index));
    });
  };

  HlandFlipClock.prototype.tick = function () {
    var totalSeconds = this.mode === 'fixed'
      ? Math.max(0, Math.ceil((this.deadline.getTime() - Date.now()) / 1000))
      : getSecondsUntilMidnight(this.timezone);
    var expired = this.mode === 'fixed' && totalSeconds <= 0;

    if (expired) {
      if (this.clockEl) this.clockEl.hidden = true;
      if (this.expiredEl) {
        this.expiredEl.textContent = this.expiredMessage;
        this.expiredEl.hidden = false;
      }
      if (this.sr) this.sr.textContent = this.expiredMessage;
      if (!this.isExpired) syncAnnounceHeight(this.root.closest('.hland-announce'));
      this.isExpired = true;
      this.lastParts = null;
      return;
    }

    if (this.clockEl) this.clockEl.hidden = false;
    if (this.expiredEl) this.expiredEl.hidden = true;
    if (this.isExpired) syncAnnounceHeight(this.root.closest('.hland-announce'));
    this.isExpired = false;
    var parts = splitCountdown(totalSeconds);

    GROUPS.forEach(function (key) {
      this.updateGroup(key, parts[key]);
    }, this);

    if (this.sr) {
      this.sr.textContent = srSummary(this.labels, parts);
    }

    this.lastParts = parts;
  };

  function syncAnnounceHeight(announce) {
    if (!announce) return;
    var h = announce.offsetHeight;
    document.documentElement.style.setProperty('--hland-announce-height', h + 'px');
  }

  function initTimer(root) {
    if (!root || root.dataset.hlandFlipBound) return;
    root.dataset.hlandFlipBound = '1';

    var clock = new HlandFlipClock(root);
    clock.tick();

    window.setInterval(function () {
      clock.tick();
    }, 1000);

    var announce = root.closest('.hland-announce');
    syncAnnounceHeight(announce);
    window.addEventListener('resize', function () {
      syncAnnounceHeight(announce);
    });
  }

  document.querySelectorAll('[data-hland-flip-clock-root]').forEach(initTimer);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hland-flip-clock-root]').forEach(initTimer);
  });
})();
